import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "cc779cf0-3709-41c9-9e0e-36d720f5b1ef",
  publicId: "4",
  name: "Volume and shape of a room and their influence on room acoustics ",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
